import React from 'react';
import {
  elementAttributesToProps,
  RehydratorFunction,
} from '@tr-digital/react-rehydrate';
import { IModuleListProps } from '../types';
import { ModuleList } from '../ModuleList';

const rehydrator: RehydratorFunction = async (domNode) => {
  const props: IModuleListProps = elementAttributesToProps(domNode);

  return Promise.resolve(<ModuleList {...props} />);
};

export default rehydrator;
